import { TextField, Toolbar, Typography } from '@mui/material';
import { useState } from 'react';


function WatchingMeetingDataTableToolbar({ pageTitle, setHighlightQuery, onSearchSubmit }) {

  const [searchInput, setSearchInput] = useState('');

  const handleSearchSubmit = () => {
    onSearchSubmit(searchInput);
    setHighlightQuery(searchInput);
  };





  return (
    <Toolbar className="table-header row" sx={{ justifyContent: 'space-between' }}>
      <div className="title">
        <Typography variant="title">{pageTitle}</Typography>
      </div>

      <div>



        <TextField
          id="searchText1xe"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearchSubmit();
            }
          }}
          margin="dense"
          label={"Arama Yap"}
          className="mr-4"
          // autoFocus
          style={{ width: "400px", background: 'white' }}
          placeholder={"Aradıktan sonra Enter'a basın"}
        />
      </div>

    </Toolbar>
  );
}

export default WatchingMeetingDataTableToolbar